// IMPORT BASE-MODULE
import BaseModule from "@core/modules/base-module/base-module";
import VideoCard from "@core/components/cards/video-card/video-card";

const videosBlock = new BaseModule();
videosBlock.name = "videos-block";
videosBlock.init(that => {
  const videoCard = new VideoCard(that.elements);
  videoCard.init();
});
